// Shared constants across components

export const COUNTRY_CODES = [
  { code: "+254", name: "Kenya (+254)" },
  { code: "+256", name: "Uganda (+256)" },
  { code: "+255", name: "Tanzania (+255)" },
  { code: "+250", name: "Rwanda (+250)" },
  { code: "+251", name: "Ethiopia (+251)" },
  { code: "+234", name: "Nigeria (+234)" },
  { code: "+233", name: "Ghana (+233)" },
  { code: "+27", name: "South Africa (+27)" },
  { code: "+1", name: "USA/Canada (+1)" },
  { code: "+44", name: "UK (+44)" },
  { code: "+49", name: "Germany (+49)" },
  { code: "+33", name: "France (+33)" },
];

export const DEFAULT_CURRENCY = "UGX";

export const CURRENCIES = [
  { code: "USD", name: "US Dollar", symbol: "$" },
  { code: "EUR", name: "Euro", symbol: "€" },
  { code: "KES", name: "Kenyan Shilling", symbol: "KSh" },
  { name: "Ugandan Shilling", code: "UGX", symbol: "USh" },
  { name: "Tanzanian Shilling", code: "TZS", symbol: "TSh" },
  { name: "Rwandan Franc", code: "RWF", symbol: "RF" },
  { name: "Ethiopian Birr", code: "ETB", symbol: "Br" },
  { name: "Ghanaian Cedi", code: "GHS", symbol: "₵" },
  { name: "Nigerian Naira", code: "NGN", symbol: "₦" },
  { name: "South African Rand", code: "ZAR", symbol: "R" },
];

export const DEFAULT_COUNTRY_CODE = "+254"; // Kenya
